import { getAuth } from "firebase/auth";
import { getReadyAuthUser } from "~/utils/auth/waitForAuthReady";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { loadCookiesData, resolveActorUserName } from "~/utils";

export const HelpPageLoader = async ({
  request,
}: LoaderFunctionArgs): Promise<HelpPageLoaderType | Response> => {
  const auth = getAuth();
  const user = await getReadyAuthUser();
  if (!user) return redirect("/explore");
  const authAccessInfo = await loadCookiesData(user.uid);
  if (!authAccessInfo.success) return redirect("/explore");

  const userName = await resolveActorUserName(user, authAccessInfo);
  return { userName };
};

export type HelpPageLoaderType = {
  userName: string;
};
